import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html {
        scroll-behavior: smooth;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: #FFFFFF;
        overflow-x: hidden;
    }

    a:hover {
        color: #1A73E8;
    }

    input,
    textarea {
        border-radius: 6px;
        border: 1px solid #E0E4E8;
        background: #F7F8FA;
        transition: all 0.3s ease-in-out;
        outline: none;
        width: 100%;
        padding: 0.875rem 1.25rem;
        font-size: 0.95rem;
        font-family: 'Motiva Sans Light', sans-serif;

        :focus-within {
            background: #FFFFFF;
            border-color: #1A73E8;
            box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
        }
    }

    h1 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 48px;
        line-height: 1.2;
        font-weight: 600;

        @media only screen and (max-width: 890px) {
            font-size: 38px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 28px;
        }
    }

    h2 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 40px;
        line-height: 1.25;

        @media only screen and (max-width: 890px) {
            font-size: 32px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 26px;
        }
    }

    h3 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 32px;
        line-height: 1.3;

        @media only screen and (max-width: 890px) {
            font-size: 28px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 22px;
        }
    }

    h4 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 26px;
        line-height: 1.35;

        @media only screen and (max-width: 890px) {
            font-size: 22px;
        }

        @media only screen and (max-width: 414px) {
            font-size: 20px;
        }
    }

    h5 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 22px;
        line-height: 1.4;

        @media only screen and (max-width: 890px) {
            font-size: 18px;
        }
    }

    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #1A73E8;
        font-size: 18px;
        line-height: 1.45;

        @media only screen and (max-width: 890px) {
            font-size: 16px;
        }
    }

    p {
        color: #1A1A1A;
        font-size: 18px;
        line-height: 1.6;

        @media only screen and (max-width: 890px) {
            font-size: 16px;
        }
    }

    a {
        text-decoration: none;
        outline: none;
        color: #1A73E8;

        :hover {
            color: #1A73E8;
        }
    }

    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
